import { Component } from '@angular/core';

@Component({
  selector: 'app-parking-about',
  imports: [],
  templateUrl: './parking-about.component.html',
  styleUrl: './parking-about.component.scss'
})
export class ParkingAboutComponent {

}
